import {
    useState,
    forwardRef,
    useImperativeHandle,
    useContext,
    useRef,
} from "react"

import ApplicantDataFormContext from "../../Contexts/ApplicantDataFormContext"
import TextInput from "../TextInput"

const FullNameAkaSelector = forwardRef(({ title, data, readOnly }, ref) => {

    const applicantDataForm = useContext(ApplicantDataFormContext)

    const akaList = applicantDataForm?.current?.["identity_information.full_name.aka_list"]

    const options = [
        {
            title: "Select",
            key: "",
        },
        ...akaList?.map(aka => {
            const nameFields = [aka.firstName]
            if (aka.middleName) {
                nameFields.push(aka.middleName)
            }
            nameFields.push(aka.lastName)
            if (aka.otherGeneration) {
                nameFields.push(aka.otherGeneration)
            }
            else if (aka.generation) {
                nameFields.push(aka.generation)
            }

            const fullName = nameFields.join(" ")
            return {
                title: fullName,
                key: fullName,
            }
        }) ?? []
    ]

    const [value, setValue] = useState(data || "")
    const [error, setError] = useState(false)

    const textInputRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            if (textInputRef.current) {

                const textResult = textInputRef.current.validateAndGetData()

                return {
                    isValid: textResult.isValid,
                    value: textResult.value,
                }
            }

            const validity = value ? true : false
            setError(!validity)
            return {
                isValid: validity,
                value: value,
            }
        },
    }))

    return (
        <div className="my-4">
            <label className="block text-base font-medium text-gray-700 mb-4">{title}</label>

            {
                akaList && (
                    <select
                        className="border border-gray-300 rounded-md p-2 bg-white w-full"
                        value={value}
                        disabled={readOnly}
                        onChange={(e) => {
                            setValue(e.target.value)
                        }}
                    >
                        {options.map((option) => (
                            <option key={option.title} value={option.key}>
                                {option.title}
                            </option>
                        ))}
                    </select>
                )
            }

            {
                !akaList && (
                    <TextInput
                        ref={textInputRef}
                        data={data}
                        title={""}
                    />
                )
            }

            {error && (
                <p className="mt-1 text-sm text-red-600">
                    {title} is invalid
                </p>
            )}
        </div>
    )
})

export default FullNameAkaSelector
